import React from 'react';
import c from 'classnames';

import './style.scss';

const PageHeader = ({ className = '', children }) => {

  const PageHeaderClasses = c('PageHeader', className);

  return (
    <div className={PageHeaderClasses}>
      {children ? (
        <div className="content">
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default PageHeader;
